/* eslint-disable class-methods-use-this */
import http from '../httpService';

class UserLoginAttemptService {
  async getAll(pagedFilterAndSortedRequest) {
    const result = await http.get('api/services/app/UserLoginAttempts/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }
}

export default UserLoginAttemptService = new UserLoginAttemptService();
